import {
  FormTab,
  Toolbar,
  TransactionLogsField,
  TransactionNotesInput,
  TransactionNotesIsPrivateInput,
  ValidationSummary,
  useSaveMutation,
} from "ra-friendsofbabba";
import React, { useMemo } from "react";
import {
  TabbedForm,
  required,
  useNotify,
  usePermissions,
  useRedirect,
  useRefresh,
} from "react-admin";

import CronoField from "../component/field/CronoField";
import DataInput from "./inputs/DataInput";
import EquipmentsField from "./fields/EquipmentsField";
import { Group } from "ra-friendsofbabba";
import { GroupTitle } from "ra-friendsofbabba";
import Input from "../component/input/Input";
import { MediaInput } from "../component/input";
import PrintAlert from "../component/alert/PrintAlert";
import { PrintButton } from "../component/button";
import { ReferenceAutocompleteInput } from "ra-friendsofbabba";
import TextContentInput from "../component/input/TextContentInput";
import WpsField from "./fields/WpsField";
import { get } from "lodash";

const Form = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const save = useSaveMutation({
    ...props,
    onSuccess: (response, values) => {
      const prevState = get(values, "transaction.state");
      const nextState = get(response, "data.state");
      const isMoved = prevState !== nextState;
      notify(
        `resources.executive-projects.messages.${values.state}_${
          isMoved ? "moved" : "loop"
        }.save_success`
      );
      if (values.id > 0) {
        refresh();
      } else {
        redirect("edit", props.basePath, response.data.id);
      }
    },
  });
  const { loaded, permissions } = usePermissions();
  const { isAdmin, isTro, isManager } = useMemo(
    () => ({
      isAdmin: loaded && permissions(["admin"]),
      isTro: loaded && permissions(["tro"]),
      isManager: loaded && permissions(["manager"]),
    }),
    [loaded, permissions]
  );
  const wps =
    get(props.record, "executive_project_wps") === []
      ? null
      : get(props.record, "executive_project_wps");

  return (
    <TabbedForm
      {...props}
      save={save}
      initialValues={{
        foreign_months: 0,
      }}
      warnWhenUnsavedChanges
      toolbar={<Toolbar useWorkflow maxButtonsToDisplay={1} />}
    >
      <FormTab label={`resources.executive-projects.tabs.general`}>
        {!isTro && <ValidationSummary />}
        <Input
          source="user_id"
          fullWidth
          validate={required()}
          component={
            <ReferenceAutocompleteInput reference="users" optionText="name" />
          }
        />
        <Input
          source="research_project_id"
          fullWidth
          validate={required()}
          component={
            <ReferenceAutocompleteInput
              reference="research-projects"
              optionText="title"
            />
          }
        />

        <Input source="public_data" fullWidth component={<DataInput />} />
        <Input source="private_data" fullWidth component={<DataInput />} />

        <TextContentInput
          source="expected_results"
          maxLength={2000}
          fullWidth
          multiline
        />
        <Group wrapper>
          <GroupTitle title="Logs" />
          <TransactionLogsField source="logs" admin={isAdmin} fullWidth />
        </Group>
        {(isAdmin || isManager) && (
          <TransactionNotesInput
            source="notes"
            helperText="resources.transactions.fields.notes.help"
            fullWidth
          />
        )}
        {(isAdmin || isManager) && (
          <TransactionNotesIsPrivateInput
            admin
            source="is_private"
            helperText="resources.transactions.fields.is_private.help"
            fullWidth
          />
        )}
      </FormTab>
      <FormTab label={"resources.executive-projects.tabs.wps"}>
        {!isTro && <ValidationSummary />}

        <Input
          source="executive_project_wps"
          component={<WpsField />}
          fullWidth
        />

        <CronoField wps={wps} />
      </FormTab>
      <FormTab label={"resources.executive-projects.tabs.equipments"}>
        <Input
          source="executive_project_equipments"
          component={<EquipmentsField />}
          fullWidth
        />
      </FormTab>
      <FormTab label={"resources.executive-projects.tabs.signed_doc"}>
        {!isTro && <ValidationSummary />}
        <PrintAlert>
          <PrintButton label="ra.action.generate_pdf" />
        </PrintAlert>
        <Input source="media" component={<MediaInput />} />
      </FormTab>
    </TabbedForm>
  );
};
export default Form;
